var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Attio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#246BFA",
    d: "M12 2.4 2.4 21.6h4.32L12 11.04l5.28 10.56h4.32L12 2.4Zm0 13.44-2.16 4.32h4.32L12 15.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttioLogo);
export default __webpack_public_path__ + "static/media/attio-logo.8e79a816e9519bb955a9045e15df394f.svg";
export { ForwardRef as ReactComponent };